import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ResetPassword from './pages/ResetPassword';
import RedirectAppButtons from './pages/RedirectToApp';
import ThankYouPage from './pages/ThankYouPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/app-redirect" element={<RedirectAppButtons />} />
        <Route path="/checkout-success" element={<ThankYouPage />} />
      </Routes>
    </Router>
  );
}

export default App;
